export const chartBarColor = 'rgb(83, 168, 226)';
export const chartTextColor = 'rgb(176, 176, 176)';
export const chartDoughnutColors = [
  "rgb(83, 168, 226)",
  "rgb(238, 106, 34)",
  "rgb(242, 175, 29)",
  "rgb(175, 180, 154)",
  "rgb(202, 49, 11)"
];